import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be7468b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "attachments-image"
}

import ImageAttachment from "@/components/chat/chatContainer/ImageAttachment/ImageAttachment.vue";
import ChatMessageContent from "@/components/chat/chatContainer/ChatMessageContent/ChatMessageContent.vue";
import VideoPlayer from "@/components/chat/chatContainer/VideoPlayer/VideoPlayer.vue";
import OtherAttachment from "@/components/chat/chatContainer/OtherAttachment/OtherAttachment.vue";
import ChatMessageSender from "@/components/chat/chatContainer/ChatMessageSender/ChatMessageSender.vue";
import { getMessageClass } from "@/utils/message";
import { getIsAttachmentsImageDisplayed } from "@/utils/chat";
import { containsOnlyEmojis } from "@/utils/emoji";
import { Message, TextMessage } from "@/store/chats/types";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import DeletedMessage from "../DeletedMessage/DeletedMessage.vue";
import { computed } from "vue";

interface ChatMessageProps {
  message: TextMessage;
  index: number;
  visibleMessages: Message[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatTextMessage',
  props: {
    message: {},
    index: {},
    visibleMessages: {}
  },
  setup(__props: any) {

const props = __props;
const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const isMine = computed(() => props.message.senderId === authId.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChatMessageContent, {
    index: _ctx.index,
    message: _ctx.message,
    "visible-messages": _ctx.visibleMessages
  }, {
    imageAttachment: _withCtx(() => [
      (_unref(getIsAttachmentsImageDisplayed)(_ctx.message))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message?.imageAttachments, (attachment) => {
              return (_openBlock(), _createBlock(ImageAttachment, {
                key: attachment.id,
                attachment: attachment,
                "gallery-mode": true,
                message: _ctx.message
              }, null, 8, ["attachment", "message"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    videoPlayer: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message?.videoAttachments, (attachment) => {
        return (_openBlock(), _createBlock(VideoPlayer, {
          key: attachment.id,
          attachment: attachment,
          message: _ctx.message,
          class: _normalizeClass(_unref(getMessageClass)(_ctx.visibleMessages, _ctx.index, _unref(authId)))
        }, null, 8, ["attachment", "message", "class"]))
      }), 128))
    ]),
    default: _withCtx(() => [
      _createVNode(ChatMessageSender, _normalizeProps(_guardReactiveProps(props)), null, 16),
      (_ctx.message?.messageText)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["message-text", { large: _unref(containsOnlyEmojis)(_ctx.message.messageText) }]),
            innerHTML: _ctx.message.parseMessageText
          }, null, 10, _hoisted_1))
        : _createCommentVNode("", true),
      (_ctx.message?.isDeleted)
        ? (_openBlock(), _createBlock(DeletedMessage, {
            key: 1,
            "is-mine": isMine.value,
            "message-type": _ctx.message.type
          }, null, 8, ["is-mine", "message-type"]))
        : _createCommentVNode("", true),
      (_ctx.message?.othersAttachments?.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["attachments-others", _ctx.message?.messageText ? 'padding-top' : ''])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.othersAttachments, (attachment) => {
              return (_openBlock(), _createBlock(OtherAttachment, {
                key: attachment.id,
                attachment: attachment,
                message: _ctx.message
              }, null, 8, ["attachment", "message"]))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.message?.imageAttachments?.length === 1)
        ? (_openBlock(), _createBlock(ImageAttachment, {
            key: 3,
            attachment: _ctx.message.imageAttachments[0],
            message: _ctx.message
          }, null, 8, ["attachment", "message"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["index", "message", "visible-messages"]))
}
}

})